"use strict";
/* eslint-disable import/prefer-default-export */
/**
 * @packageDocumentation
 * @module DataUtils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSignature = exports.validateHash = exports.validateAddress = void 0;
const util_crypto_1 = require("@polkadot/util-crypto");
const _1 = require(".");
const Crypto_1 = require("./Crypto");
/**
 *  Validates an given address string against the External Address Format (SS58) with our Prefix of 38.
 *
 * @param address Address string to validate for correct Format.
 * @param name Contextual name of the address, e.g. "claim owner".
 * @throws [[ERROR_ADDRESS_TYPE]] when address not of type string or of invalid Format.
 *
 * @returns Boolean whether the given address string checks out against the Format.
 */
function validateAddress(address, name) {
    if (typeof address !== 'string') {
        throw _1.SDKErrors.ERROR_ADDRESS_TYPE();
    }
    // KILT has registered ss58 prefix 38
    if (!util_crypto_1.checkAddress(address, 38)[0]) {
        throw _1.SDKErrors.ERROR_ADDRESS_INVALID(address, name);
    }
    return true;
}
exports.validateAddress = validateAddress;
/**
 *  Validates the format of the given blake2b hash via regex.
 *
 * @param hash Hash string to validate for correct Format.
 * @param name Contextual name of the address, e.g. "claim owner".
 * @throws [[ERROR_HASH_TYPE]] when hash not of type string or of invalid Format.
 *
 * @returns Boolean whether the given hash string checks out against the Format.
 */
function validateHash(hash, name) {
    if (typeof hash !== 'string') {
        throw _1.SDKErrors.ERROR_HASH_TYPE();
    }
    const blake2bPattern = new RegExp('(0x)[A-F0-9]{64}', 'i');
    if (!hash.match(blake2bPattern)) {
        throw _1.SDKErrors.ERROR_HASH_MALFORMED(hash, name);
    }
    return true;
}
exports.validateHash = validateHash;
/**
 *  Validates the signature of the given signer address against the signed data.
 *
 * @param data The signed string of data.
 * @param signature The signature of the data to be validated.
 * @param signer Address of the signer identity.
 * @throws [[ERROR_SIGNATURE_DATA_TYPE]] when parameters are of invalid type.
 * @throws [[ERROR_SIGNATURE_UNVERIFIABLE]] when the signature could not be validated against the data.
 *
 * @returns Boolean whether the signature is valid for the given data.
 */
function validateSignature(data, signature, signer) {
    if (typeof data !== 'string' ||
        typeof signature !== 'string' ||
        typeof signer !== 'string') {
        throw _1.SDKErrors.ERROR_SIGNATURE_DATA_TYPE();
    }
    if (!Crypto_1.verify(data, signature, signer)) {
        throw _1.SDKErrors.ERROR_SIGNATURE_UNVERIFIABLE();
    }
    return true;
}
exports.validateSignature = validateSignature;
